import React, {useCallback, useMemo} from 'react';
import TooltipInput from '@/components/TooltipInput/TooltipInput';
import fieldInfoContent from '@/Pages/ProductionCost/constants/fieldInfoContent';
import {useAppDispatch} from '@/Pages/Common/hooks/useAppDispatch';
import {updateVehicleEntryByIds} from '@/Pages/ProductionCost/store/slice';
import {validateInputNumber} from '@/Pages/Common/Utils';
import {AnnualCrewMemberSalaryProps} from './AnnualCrewMemberSalary.types';
import styles from './AnnualCrewMemberSalary.module.scss';

const AnnualCrewMemberSalary: React.FC<AnnualCrewMemberSalaryProps> = ({
  value,
  entryId,
  currency,
  errors
}) => {
  const dispatch = useAppDispatch();

  const id = `entry-${entryId}-annual-crew-member-salary`;

  const tooltipContent = useMemo(() => fieldInfoContent.crewMemberSalary, []);

  const handleInputChange = useCallback(
    (editedValue: string) => {
      const crewMemberSalary =
        validateInputNumber(
          editedValue,
          value ? value.toString() : '',
          undefined,
          0
        ) ?? undefined;

      dispatch(
        updateVehicleEntryByIds({
          entryIds: [entryId],
          updates: {crewMemberSalary}
        })
      );
    },
    [entryId, value, dispatch]
  );

  const formattedValue = useMemo(
    () => (typeof value === 'number' ? value.toString() : ''),
    [value]
  );

  return (
    <span className={styles.container}>
      <TooltipInput
        id={id}
        name="crew-member-salary"
        label="Annual crew member salary"
        inlineLabelLeft={currency}
        value={formattedValue}
        tooltipContent={tooltipContent}
        valid={!errors}
        infoError={errors?.optionality ?? errors?.nullable}
        handleInputChange={handleInputChange}
      />
    </span>
  );
};

export default React.memo(AnnualCrewMemberSalary);
